var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SchedulePanels',{attrs:{"protocol":_vm.protocol,"cpf":_vm.cpf,"cellphone":_vm.cellphone}})}
var staticRenderFns = []

export { render, staticRenderFns }